import type { IErrorResponse, LoginRequest, LoginResponse } from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { useTranslation } from '@/hooks';
import { urls } from '@/statics';
import { api, standaloneToast } from '@/utils';
import { googleEventLogin } from '@/utils/googleAnalyticsEvent';

const useLogin = (): UseMutationResult<
  LoginResponse,
  IErrorResponse,
  LoginRequest
> => {
  const { t } = useTranslation('messages');

  return useMutation({
    mutationFn: (data) => api.post(urls.login, data),
    onSuccess: () => {
      standaloneToast({
        status: 'success',
        title: t('welcomeToLogin'),
      });
      googleEventLogin();
    },
  });
};

export default useLogin;
